"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSvgIcon = _interopRequireDefault(require("../utils/createSvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "16",
  cy: "23.36",
  r: "2.24"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "16",
  cy: "16",
  r: "2.24"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "16",
  cy: "8.64",
  r: "2.24"
})), {
  viewBox: '0 0 32 32'
});
module.exports = exports.default;